
export class Link {
    constructor(
            )
    { }
    public texto: string; 
    public urlInterno: string;
    public urlExterno: string;
}